'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

const SAFETY_SLUG = '/bezpecnostne-sprchy';

export function BodyClientOverride() {
  const pathname = usePathname();

  useEffect(() => {
    const html = document.documentElement;
    if (pathname.includes(SAFETY_SLUG)) {
      html.setAttribute('data-primary-theme', 'safety');
    } else {
      html.removeAttribute('data-primary-theme');
    }
  }, [pathname]);

  return null;
}
